import { ref, reactive } from 'vue'

// Глобальное состояние уведомлений
const notifications = ref([])
let notificationId = 0

export function useNotifications() {
  const showNotification = (type, message, duration = 5000) => {
    const id = ++notificationId

    const notification = {
      id,
      type, // 'success', 'error', 'warning', 'info'
      message,
      timestamp: new Date(),
      visible: true
    }

    notifications.value.push(notification)

    // Автоматически убираем уведомление через duration
    if (duration > 0) {
      setTimeout(() => {
        hideNotification(id)
      }, duration)
    }

    return id
  }

  const hideNotification = (id) => {
    const index = notifications.value.findIndex(n => n.id === id)
    if (index > -1) {
      notifications.value.splice(index, 1)
    }
  }

  const clearAllNotifications = () => {
    notifications.value = []
  }

  // Удобные методы для разных типов уведомлений
  const showSuccess = (message, duration) => showNotification('success', message, duration)
  const showError = (message, duration) => showNotification('error', message, duration)
  const showWarning = (message, duration) => showNotification('warning', message, duration)
  const showInfo = (message, duration) => showNotification('info', message, duration)

  return {
    notifications,
    showNotification,
    hideNotification,
    clearAllNotifications,
    showSuccess,
    showError,
    showWarning,
    showInfo
  }
}